import type {
  Contact, HouseholdFullData, SelectedArticle, PhoneNumber,
} from './common';
import type { Household } from './household';
import type { Address } from './address';

export enum ConnectionType {
  SWITCHING_PROVIDER,
  NEW_CONNECTION,
  NONE,
}

export enum OrdererRelationToBuilding {
  IS_OWNER,
  IS_ADMINISTRATOR,
  IS_NOT_OWNER_OR_ADMINISTRATOR,
}

export enum LocalContactPerson {
  ORDERER,
  ADMINISTRATOR,
  OTHER,
}

export interface StepOrderRequestData {
  blockProductBooking: boolean;
  bookingWithProduct: boolean;
  connectionPoint: string;
  iban: string;
  isMphOrder: boolean;
  ne4Order: string;
  price: number;
  wantsBankTransfer: boolean;
  blockMphBooking: boolean;
}

export interface StepOrdererData {
  appointmentDate: string | null;
  contact: Contact;
  contactingAppointment: boolean;
  household: Household;
  invoiceAddress: Address | null;
  address: Address;
  isClientsAddress: boolean;
  isOwnerOrManager: string;
  notOwnerNeitherManager: boolean;
  additionalInfo?: string;
}

export interface StepMphData {
  administrator: HouseholdFullData;
  buildingUnderConstruction: boolean;
  buildingUseFromDate: string;
  contactPerson: HouseholdFullData;
  differentContactPerson: string;
  existsAnAdministrator: boolean;
  isCommunityOfOwners: boolean;
  numberOfCommercialUnits: number;
  numberOfFloors: number;
  numberOfResidentialUnits: number;
  numberOfOwners: number;
  ne4ExtensionPrice: number;
  ne4ExtensionDiscountedPrice: number;
  ne4Discount: number;
  salesPartnerEmailAddress: string | null;
  netzLeadId: string | null;
}

export interface StepProductData {
  selections: SelectedArticle[];
  appliedActionCode: string;
}

export interface StepCustomerData {
  creditCheck: boolean;
  customerPassword: string;
  extendedDataUsage: boolean;
  dataUsage: boolean;
  iban: string;
  itemizedBill: string;
  numberPortability: boolean;
  otherConnectionOwners: boolean;
  otherConnectionOwnersData?: Household[];
  otherProvider: string;
  phoneBookEntry: string;
  portablePhoneNumbers?: PhoneNumber[];
  referralCode: string;
  selectedProvider: string;
  connectionType?: ConnectionType;
  telephoneAdvertisement: boolean;
  wantsBankTransfer: boolean;
  phoneNumberChange: PhoneNumber;
}

export interface StepOwnerData {
  isOwner: boolean;
  isManager: boolean;
  household: Household;
  isClientsAddress: boolean;
  address?: Address;
}

export interface StepSummaryData {
  externalOrderNumber: string;
  isSubsequentRecordingOfEECCOrder: boolean;
}
